import { feedItems } from "../../../mocks/starTracker";

const tagColor: Record<string, string> = {
  离婚诉讼: "bg-primary-100 text-primary-700",
  公开回应: "bg-accent-100 text-accent-700",
  道歉: "bg-secondary-100 text-secondary-800",
  塌房风险: "bg-primary-600 text-background-50",
  舆论反转: "bg-accent-500 text-background-50",
  圈内发声: "bg-secondary-200 text-secondary-800",
};

export default function LiveFeed() {
  return (
    <section id="live" className="bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6 lg:px-10">
        <div className="flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-700">
              <i className="ri-flashlight-fill text-base"></i>
              实时追踪
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              最新进展 · 时间线式滚动更新
            </h2>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
              事件不会停留在“爆出”那一刻。真正值得追踪的，是之后每一次回应、道歉与程序性动作如何改变走向。
            </p>
          </div>
          <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-3 py-1.5 text-xs font-medium text-secondary-700 ring-1 ring-background-200">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-500 opacity-60"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-600"></span>
            </span>
            内容持续核验更新
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {feedItems.map((f, idx) => (
            <article
              key={f.id}
              className="flex flex-col rounded-lg bg-background-50 p-5 ring-1 ring-background-200 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="flex items-center justify-between">
                <span className={`inline-flex whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-semibold ${tagColor[f.tag]}`}>
                  {f.tag}
                </span>
                <span className="flex items-center gap-1 text-xs text-secondary-500 whitespace-nowrap">
                  <i className="ri-fire-fill text-primary-500"></i>
                  热度 {f.heat}
                </span>
              </div>
              <h3 className="mt-3 flex-1 font-heading text-base font-bold leading-snug text-foreground-950">
                {idx + 1 < 10 ? `0${idx + 1} · ` : `${idx + 1} · `}
                {f.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{f.digest}</p>
              <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                <span className="flex items-center gap-1.5 text-xs text-secondary-500 whitespace-nowrap">
                  <i className="ri-time-line"></i>
                  {f.time}
                </span>
                <button
                  type="button"
                  className="inline-flex items-center gap-1 text-xs font-semibold text-primary-700 hover:text-primary-600 whitespace-nowrap"
                >
                  查看复盘 <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-6 flex justify-center">
          <button
            type="button"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-800 ring-1 ring-background-300 transition-colors hover:bg-secondary-100"
          >
            加载更多进展 <i className="ri-arrow-down-s-line text-base"></i>
          </button>
        </div>
      </div>
    </section>
  );
}